/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React from "react";
import { Redirect, Route } from "react-router-dom";
import { AuthConsumer } from "./AuthContext";
import RenderFullPageLoading from "./assets/component/RenderFullPageLoading.js";

function run(Component, rest) {
  function renderComponent(t, props, adminLogin, language) {
    const currentPath = props.location.pathname.substring(1).toUpperCase();
    //set language Data
    const languageObj = t(currentPath, { returnObjects: true });
    return (
      <Component
        {...props}
        adminLogin={adminLogin}
        languageObj={languageObj}
        RenderFullPageLoading={RenderFullPageLoading}
      />
    );
  }

  return (
    <AuthConsumer>
      {({ isAdminAuth, adminLogin, t, language }) => (
        <Route
          render={(props) =>
            isAdminAuth ? (
              <Redirect to="/Admin" />
            ) : (
              renderComponent(t, props, adminLogin, language)
            )
          }
          {...rest}
        />
      )}
    </AuthConsumer>
  );
}

const AdminLoginRoute = ({ component: Component, ...rest }) =>
  run(Component, rest);

export default AdminLoginRoute;
